:host {
  display: block !important;
  all: initial;
}
:root {
  --primary-bg-color: #4dc247;
  --primary-text-color: #fff;
}
.whatsapp-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 12px;
  right: 8px;
  cursor: pointer;
  z-index: 1000;
  font-family: 'system-ui';
}
.chat-circle {
  background-color: #25d366;
  background-image: url("/assets/images/whatsapp-logo.svg");
  background-size: 40px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.whatsapp-image {
  width: 40px;
  height: 40px;
}

.chat-box {
  background-color: white;
  width: 320px;
  border-radius: 8px;
  box-shadow: 0px 5px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  border-radius: 4px;
}

.chat-box-header {
  padding: 15px;
  background-color: #25d366;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.chat-title {
  font-weight: 500;
  color: #fff;
  font-family: 'system-ui';
}

.chat-box-toggle {
  cursor: pointer;
  width: 22px;
  height: 22px;
}

.chat-box-overlay {
  position: relative;
  overflow: hidden;
  background-color: #efefef;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.chat-box-body::after {
  content: "";
  background-image: url("data:image/svg+xml;base64,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");
  opacity: 0.1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  height: 100%;
  position: absolute;
  z-index: 0;
  overflow: hidden;
}

input,
.chat-box-header,
textarea,
.send-button,
.chat-accreditation {
  position: relative;
  z-index: 1;
}

.chat-input > form {
  margin-bottom: 0;
}

#chat-input::placeholder {
  color: #ccc;
}

.chat-submit {
  box-shadow: none;
  border: none;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  width: 50px;
  height: 50px;
  margin: 20px auto 0;
  cursor: pointer;
  background: #4dc247 url("./images/send.svg") no-repeat center;
  background-color: var(--primary-bg-color);
  background-size: 20px;
  font-family: 'system-ui';
}

.chat-logs {
  padding: 15px 25px;
}

.form-group label {
  font-size: 14px;
  font-weight: 500;
  display: block;
  margin-bottom: 5px;
  margin-top: 14px;
  font-family: 'system-ui';

}

.form-group input {
  outline: none;
  font-size: 14px;
  font-family: 'system-ui';
}

.form-group .required {
  color: red;
  font-family: 'system-ui';

}

.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.error-message {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  font-family: 'system-ui';

}

.send-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
  background-color: #25d366;
  border-radius: 50%;
  padding: 12px;
  width: 22px;
  height: 22px;
  margin: auto;
}

.send-image {
  cursor: pointer;
  width: 22px;
  height: 22px;
}

.chat-accreditation {
  text-align: center;
  margin-top: 10px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
  cursor: none;
  position: relative;
  padding: 10px 0;
  font-family: 'system-ui';
}
